export const formatPrice = (pence) => `£${(pence / 100).toFixed(2)}`

export const formatTime = (isoString) => {
  const date = new Date(isoString)
  return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
}

export const generateTimeOptions = () => {
  const options = []
  const now = new Date()

  // Round current time up to next 15-minute increment
  const currentMinutes = now.getMinutes()
  const roundedMinutes = Math.ceil(currentMinutes / 15) * 15

  // Create a new date with rounded time
  const startTime = new Date(now)
  startTime.setMinutes(roundedMinutes)
  startTime.setSeconds(0)
  startTime.setMilliseconds(0)

  // Generate 8 time slots in 15-minute increments
  for (let i = 0; i < 8; i++) {
    const time = new Date(startTime.getTime() + (i * 15 * 60 * 1000))
    const hours = time.getHours().toString().padStart(2, '0')
    const minutes = time.getMinutes().toString().padStart(2, '0')
    options.push(`${hours}:${minutes}`)
  }

  return options
}
